module.exports = __webpack_public_path__ + "static/media/zera_putting_recttraingle.6e24a909.png";